/*
 * @Author: cn1994
 * @Date: 2021-06-08 10:39:15
 * @LastEditors: cn1994
 * @LastEditTime: 2022-08-10 16:24:27
 * @Description: 微信相关接口
 */

import request from '@/common/request.js'

// 新获取注入信息接口
export const getWxJsapiSignature = params => {

	return request({
		url: 'QW/qiwei/qiwei/qwsignature',
		method: 'get',
		params
	})
}

